import { connect } from 'react-redux';

import { getUpdatingFunnel } from '../../../reducers/analyticsApp';
import { setFunnelGlobalClosingRage } from '../../../actions/funnel';
import ClosingRangePicker from '../../../components/common/ClosingRangePicker';

const mapStateToProps = (state) => ({
  global: true,
  closingRange: getUpdatingFunnel(state).closingRange,
});

const mapDispatchToProps = {
  onChange: setFunnelGlobalClosingRage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClosingRangePicker);
